module.exports = __webpack_public_path__ + "static/media/shopping-cart.2b75be77.png";